// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/depression-profile-outline-gradient.svg';

export const DepressionProfileOutlineGradient = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
